

/**
* @param {name} string - Name
* @param {count} number - Number of initials
* @return {string} Initials
*/
export const getInitials = (name, count = 2) => {
  if (!name) return '';
  return name
    .split(' ')
    .map((n) => n.charAt(0))
    .join('')
    .toUpperCase()
    .substring(0, count);
};
